<script setup lang="ts">
import { PhDownloadSimple, PhX } from "@phosphor-icons/vue";

import ProductInfoSection from "../components/ProductInfoSection.vue";
import SmartFilterBar from "../components/SmartFilterBar.vue";
import StatusAlert from "../components/StatusAlert.vue";
</script>

<template>
  <section id="overviewView">
    <section class="capture-section" aria-label="素材检测">
      <ProductInfoSection />

      <div class="detection-row">
        <div
          id="detectionState"
          class="detection-state"
          data-state="checking"
        >
          <div class="detection-state-copy" role="status" aria-live="polite">
            <span class="detection-dot" aria-hidden="true"></span>
            <span id="detectionStateText">正在检测页面素材</span>
            <span id="inspectionTime" class="detection-time" hidden></span>
          </div>
        </div>
        <SmartFilterBar />
      </div>

      <section
        id="inspectionSection"
        class="inspection-section"
        aria-label="检测结果"
        aria-live="polite"
        hidden
      >
        <div class="count-list">
          <button class="asset-count asset-count--main" data-media-group="gallery" type="button">
            <strong id="galleryImageCount">0</strong>
            <small>商品主图</small>
            <span class="asset-selection-summary" data-selection-summary="gallery" data-state="none">已选 0 / 0</span>
          </button>
          <button class="asset-count asset-count--video" data-media-group="video" type="button">
            <strong id="galleryVideoCount">0</strong>
            <small>商品视频</small>
            <span class="asset-selection-summary" data-selection-summary="video" data-state="none">已选 0 / 0</span>
          </button>
          <button class="asset-count asset-count--sku" data-media-group="sku" type="button">
            <strong id="skuCount">0</strong>
            <small>SKU 图</small>
            <span class="asset-selection-summary" data-selection-summary="sku" data-state="none">已选 0 / 0</span>
          </button>
          <button class="asset-count asset-count--detail" data-media-group="detail" type="button">
            <strong id="detailCount">0</strong>
            <small>详情图片</small>
            <span class="asset-selection-summary" data-selection-summary="detail" data-state="none">已选 0 / 0</span>
          </button>
        </div>
        <div id="overviewSelectionState" class="overview-selection-state" aria-live="polite" hidden>
          <span id="overviewSelectionText">已选择 0 / 0 个素材</span>
          <button id="selectAllButton" class="select-all-button" type="button">
            <span>全选</span>
          </button>
        </div>
        <div id="analysisProgress" class="analysis-progress" hidden>
          <div
            id="analysisProgressTrack"
            class="analysis-progress-track"
            role="progressbar"
            aria-label="智能筛选进度"
            aria-valuemin="0"
            aria-valuemax="0"
            aria-valuenow="0"
          >
            <span id="analysisProgressBar" class="analysis-progress-bar"></span>
          </div>
          <span id="analysisProgressLabel" class="analysis-progress-label" aria-live="polite">已完成 0 / 0</span>
        </div>
        <p id="analysisStatus" class="analysis-status" role="status" aria-live="polite" hidden></p>
        <div class="overview-download-control">
          <button id="saveButton" class="primary-button overview-download-button" type="button" disabled>
            <span id="saveDownloadProgressFill" class="download-button-progress-fill" aria-hidden="true"></span>
            <PhDownloadSimple class="button-icon" :size="16" weight="bold" aria-hidden="true" />
            <span class="button-progress" aria-hidden="true"></span>
            <span id="saveButtonLabel" class="button-label">保存素材</span>
          </button>
          <button
            id="overviewDownloadCancelButton"
            class="download-inline-cancel"
            type="button"
            aria-label="取消当前下载"
            title="取消当前下载"
            hidden
          >
            <PhX :size="13" weight="bold" aria-hidden="true" />
          </button>
        </div>
        <StatusAlert
          alert-id="overviewDownloadAlert"
          text-id="overviewDownloadAlertText"
          close-id="overviewDownloadAlertClose"
          close-label="关闭首页下载通知"
        />
      </section>
    </section>
  </section>
</template>
